import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TProviderBrandPayloadRequest, TProviderBrandResponse, adaptProviderBrandFromResponse, adaptProviderBrandToRequest } from '../../types';
import { TSliceInitialState, useAppSelector } from '../../hooks';
import { BACKEND_ADMIN_PROVIDER_BRAND } from '../../backend-paths';


export const providerBrandCreateApi = createAsyncThunk(
	`POST/${BACKEND_ADMIN_PROVIDER_BRAND}`,
	(payload: TProviderBrandPayloadRequest, thunkApi) => {
		const dataRequest = adaptProviderBrandToRequest(payload);

		return HttpService.post<TProviderBrandResponse>(BACKEND_ADMIN_PROVIDER_BRAND, dataRequest).then(result => {
			return adaptProviderBrandFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TProviderBrandResponse> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const providerBrandCreateSlice = createSlice({
	name: 'providerBrandCreateSlice',
	initialState,
	reducers: {
		clearProviderBrandCreate(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[providerBrandCreateApi.pending.type]: (state) => {
			state.error = undefined;
			state.isLoading = true;
		},

		[providerBrandCreateApi.fulfilled.type]: (state, action: PayloadAction<TProviderBrandResponse>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[providerBrandCreateApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
	},
});

export const useProviderBrandCreateSelector = () => useAppSelector(state => state[providerBrandCreateSlice.name]);

export const { clearProviderBrandCreate } = providerBrandCreateSlice.actions;
